import { Page } from "../page";

export class QueryOverDCRequest extends Page{
    activeFlag: string | null;
    brand: string | null;
    consigneeKey: string[] | null;
    erpStorer: string | null;
    sku: string[] | null;
    language: string | null;


    constructor(){
        super();
        this.activeFlag = null;
        this.brand = null;
        this.consigneeKey = [];
        this.erpStorer = null;
        this.sku = [];
        this.language = null;
    }
}
